const light = ({ borderColor }) => borderColor;

export default light;
